<div class="chip">
  <span data-testid="file-details">
    {{ file.name }} | {{ file.size }} bytes
  </span>
</div>
<button
  style="margin-left: 1px"
  mat-icon-button
  (click)="onClickSave.emit()"
  data-testid="save-button"
>
  <mat-icon fontIcon="Bosch-Ic-save"> </mat-icon>
</button>
<button
  style="margin-left: 1px"
  mat-icon-button
  (click)="onClickRemove.emit()"
  data-testid="delete-button"
>
  <mat-icon fontIcon="Bosch-Ic-delete"> </mat-icon>
</button>
